import CardWrapper from '@/components/common/CardWrapper/CardWrapper';
import { User } from '@/Types/gql/graphql';
import { useState } from 'react';
import Rounded from './Rounded';
import MediaGallery from '@/components/common/MediaGallery/MediaGallery';
import { Clock3 } from 'lucide-react';

const tabList = [
  { label: 'Media', value: 'media' },
  { label: 'Certifications', value: 'certifications' },
  { label: 'Specializations', value: 'specializations' },
  {label:'Manage Account',value:'manageAccount'}
];
type TrainerProfileProps = {
  user: User;
};

const TrainerProfile = ({ user }: TrainerProfileProps) => {
  const [activeTab, setActiveTab] = useState('media');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'media':
        return (
          <div className=' flex flex-col gap-4 rounded-[12px]'>
            <div className='flex flex-wrap gap-3'>
              {user?.medias && user?.medias?.length > 0 ? (
                user?.medias?.map((media, index) => (
                  <div key={index} className='w-[167px] h-[167px] rounded-[10px]'>
                    {media?.type === 'VIDEO' ? (
                      <video
                        src={media?.path || ''}
                        controls
                        className='w-full h-full object-cover rounded-[10px]'
                        onClick={() => setSelectedMedia(index)}
                      />
                    ) : (
                      <img
                        src={media?.path || ''}
                        alt={`media-${index}`}
                        className='w-full h-full object-cover rounded-[10px]'
                        onClick={() => setSelectedMedia(index)}
                      />
                    )}
                  </div>
                ))
              ) : (
                <p className='text-white'>No Media Found</p>
              )}
            </div>
          </div>
        );
      case 'certifications':
        return (
          <div className=' flex flex-col gap-5 rounded-[12px]'>
            <div className='flex gap-3 items-center flex-wrap overflow-none'>
              {user?.userCertificates && user?.userCertificates?.length > 0 ? (
                user?.userCertificates?.map((certificate) => (
                  <Rounded name={certificate.certificate?.title ?? ''} key={certificate._id} />
                ))
              ) : (
                <p className='text-white'>No certificate found</p>
              )}
            </div>
          </div>
        );
      case 'specializations':
        return (
          <div className='flex flex-col gap-5  rounded-[12px]'>
            <div className='flex gap-3 items-center'>
              <div className='flex flex-wrap gap-3 items-center overflow-hidden'>
                {user?.specializations && user?.specializations?.length > 0 ? (
                  user?.specializations?.map((specialization) => (
                    <Rounded key={specialization?._id} name={specialization?.title} />
                  ))
                ) : (
                  <p className='text-white'>No Specialization Added</p>
                )}
              </div>
            </div>
          </div>
        );
        case 'manageAccount':
          return (
            <div className=' gap-5  rounded-[12px]'>
            <div className='flex gap-3 items-center '>
              <div>
              <Clock3 color='#C5C8D0'/>
              </div>
               <div className='text-white font-medium text-center'> Timezone - <span className='text-[#E9CC7C] font-bold text-base'>{user?.timezone??'N/A'} </span> </div>
            </div>
            <div className='text-bgOffWhite pl-10 text-[14px]  font-medium pt-1'>Please reach out to the admin if you wish to update your timezone. </div>
          </div>
          );
      default:
        return null;
    }
  };

    const [selectedMedia, setSelectedMedia] = useState<number | null>(null);
     const mediaData =
  user?.medias?.filter(
    (media): media is NonNullable<typeof media> => media !== null,
  ) || [];

  return (
    <div>
      {/* Tabs */}
      <div className='flex space-x-4 mb-6'>
        {tabList.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={`px-4 py-2 rounded-full focus:outline-none transition-colors duration-200 ${
              activeTab === tab.value
                ? 'bg-blue-600 text-white'
                : 'bg-gray-800 text-[#C5C8D0] hover:bg-blue-700 hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {/* Tab Content */}
      <CardWrapper className='py-2 px-10'>
        <div className='my-4'>{renderTabContent()}</div>
      </CardWrapper>
   {selectedMedia || selectedMedia === 0 ? (
          <MediaGallery
            selectedMedia={selectedMedia}
            mediaData={mediaData}
            setSelectedMedia={setSelectedMedia}
          />
        ) : (
          ''
        )}
    </div>
  );
};

export default TrainerProfile;
